import styled from 'styled-components';

import StyledDefaultVariant from './StyledDefaultVariant';

export default styled(StyledDefaultVariant)`
	display: flex;
	gap: 1rem;
	& > span {
		font-weight: 400;
		color: var(--dark-text);
	}
	b {
		font-weight: 700;
		margin: 0;
	}
	&:before {
		content: '';
		display: block;
		width: 0.4rem;
		height: 2.2rem;
		background-color: var(--cd-color);
	}
`;
